<div class="if-dlg">

  <div class="if-dlg__head">
    <div class="if-dlg__head-left">
      <div class="if-dlg__icon"><mat-icon>business</mat-icon></div>
      <span class="if-dlg__title">Inversión en Empresas</span>
      <mat-icon *ngIf="saved" class="if-dlg__saved">check_circle</mat-icon>
    </div>
    <button mat-icon-button (click)="closeDialog()" aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="if-dlg__body">

    <div class="if-import-banner" *ngIf="flagImport">
      Importación: <strong>{{ movement.reference }}</strong>
    </div>

    <div class="if-layout if-layout--2" *ngIf="ready">

      <!-- Columna 1 — Datos -->
      <div class="if-col">
        <div class="if-section">
          <div class="if-section__head">
            <mat-icon>info</mat-icon> Datos de la inversión
          </div>
          <div class="if-section__body">

            <div class="if-field">
              <app-autocomplete-select [items]="accounts"
                [(selectedItemId)]="investmentInCompanies.accountingModelsNumber"
                [idField]="'number'" [displayFields]="['number', 'name']" placeholder="Tipo inversión"
                (selectionChanged)="change($event)">
              </app-autocomplete-select>
              <app-help key='Inversion7'></app-help>
            </div>

            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Valor de la inversión</mat-label>
              <input matInput min="0" [(ngModel)]="investmentInCompanies.investmentValue"
                name="investmentInCompanies.investmentValue" required />
            </mat-form-field>

            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Fecha inversión</mat-label>
              <input matInput [matDatepicker]="investmentDate" name="investmentInCompanies.investmentDate"
                [(ngModel)]="investmentInCompanies.investmentDate" required />
              <mat-datepicker-toggle matSuffix [for]="investmentDate"></mat-datepicker-toggle>
              <mat-datepicker #investmentDate></mat-datepicker>
            </mat-form-field>

            <app-input inputType="text" placeholder="Descripción" name="investmentInCompanies.investmentDescription"
              [isRequired]="true" [(ngModel)]="investmentInCompanies.investmentDescription"></app-input>

          </div>
        </div>

        <div class="if-section">
          <div class="if-section__head">
            <mat-icon>show_chart</mat-icon> Participaciones y rendimientos
          </div>
          <div class="if-section__body">

            <div class="if-field">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>N.º participaciones o acciones</mat-label>
                <input matInput min="0" [(ngModel)]="investmentInCompanies.numberOfUnitsOrSharesInvested"
                  name="investmentInCompanies.numberOfUnitsOrSharesInvested" />
              </mat-form-field>
              <app-help key='Inversion8'></app-help>
            </div>

            <div class="if-field">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>% rentabilidad / interés</mat-label>
                <input matInput min="0"
                  [(ngModel)]="investmentInCompanies.percentageOfProfitabilityOrInterest"
                  name="investmentInCompanies.percentageOfProfitabilityOrInterest" />
              </mat-form-field>
              <app-help key='Inversion9'></app-help>
            </div>

            <div class="if-field">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Plazo (meses)</mat-label>
                <input matInput type="number" min="0" [(ngModel)]="investmentInCompanies.termInMonths"
                  name="investmentInCompanies.termInMonths" />
              </mat-form-field>
              <app-help key='Inversion10'></app-help>
            </div>

            <div class="if-field">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Valor neto del último balance</mat-label>
                <input matInput min="0" [(ngModel)]="investmentInCompanies.netBookValue"
                  name="investmentInCompanies.netBookValue" />
              </mat-form-field>
              <app-help key='Inversion11'></app-help>
            </div>

            <div class="if-field">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Fecha último balance</mat-label>
                <input matInput [matDatepicker]="lastBalanceSheetDate"
                  name="investmentInCompanies.lastBalanceSheetDate"
                  [(ngModel)]="investmentInCompanies.lastBalanceSheetDate" />
                <mat-datepicker-toggle matSuffix [for]="lastBalanceSheetDate"></mat-datepicker-toggle>
                <mat-datepicker #lastBalanceSheetDate></mat-datepicker>
              </mat-form-field>
              <app-help key='Inversion12'></app-help>
            </div>

            <mat-slide-toggle (change)="changeToggleGeneratesReturns($event)"
              [checked]="investmentInCompanies.generatesReturns" name="generatesReturns">
              Genera rendimientos
            </mat-slide-toggle>

          </div>
        </div>
      </div>

      <!-- Columna 2 — Documento -->
      <div class="if-col">
        <div class="if-section">
          <div class="if-section__head">
            <mat-icon>attach_file</mat-icon> Documento adjunto
          </div>
          <div class="if-section__body">
            <div class="if-file-area">
              <app-add-file [originEntity]="originEntity" [filePath]="filePath" [imageTempUrl]="imageTempUrl"
                (CallbackParameters)="SetFileParameters($event)">
              </app-add-file>
              <ng-container *ngIf="readyLoadedFiles === false">
                <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
              </ng-container>
              <div class="if-file-preview" *ngIf="imageTempUrl != null">
                <div class="imageFile" *ngIf="investmentInCompanies.isImage">
                  <app-image-zoom [src]="imageTempUrl"></app-image-zoom>
                </div>
                <div class="pdf-container" *ngIf="investmentInCompanies.isPdf">
                  <ngx-extended-pdf-viewer [src]="imageTempUrl" [useBrowserLocale]="true"
                    [height]="'70%'" [textLayer]="false">
                  </ngx-extended-pdf-viewer>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>

  <div class="if-dlg__foot">
    <button mat-stroked-button class="if-btn-cancel" (click)="closeDialog()">Cancelar</button>
    <button mat-flat-button class="if-btn-save" (click)="save()">
      <mat-icon>save</mat-icon> Guardar
    </button>
  </div>

</div>
